export default {
  benefits: {
    earn_points: 'Guadagna punti ad ogni ordine',
    get_deals: 'Ricevi sconti esclusivi',
    redeem_points: 'Riscatta punti per cibo gratuito',
  },
};
